/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SharedKernelAddress { 
    name?: string | null;
    address1?: string | null;
    address2?: string | null;
    postalCode?: string | null;
    city?: string | null;
    countryId?: string | null;
}

